import { useTranslation } from 'react-i18next';

import { getAmount } from 'libs/common';
import { Content } from './sum.styled';

export const Sum = (props) => {
  const { value, title = 'sum' } = props;
  const sum = getAmount(value);
  const { t } = useTranslation();

  return (
    <Content>
      {t('grid.' + title)}:&nbsp;<span>{sum}</span>
    </Content>
  );
};
